/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementDialogSendMailController', MemberManagementDialogSendMailController);

    MemberManagementDialogSendMailController.$inject = ['$uibModalInstance', 'AlertService', '$http'];

    function MemberManagementDialogSendMailController ($uibModalInstance, AlertService, $http) {

        var vm = this;
        vm.clear = clear;
        vm.action = action;
        vm.sendMail = {startId: 0};

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        function action(action) {
            vm.sendMail.action = action;
            vm.isSaving = true;
            $http.post('api/board/profiles/mail/', vm.sendMail).then(function(response) {
                vm.isSaving = false;
                if(action !== "test") {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        }
    }
})();
